import { notifyError } from "../ui/dls/dls-snackbar/dls-snackbar";

//@ts-expect-error window.ENV
export const ACCESS_TOKEN_KEY = window.ENV.ACCESS_TOKEN_KEY;
//@ts-expect-error window.ENV
export const ID_TOKEN_KEY = window.ENV.ID_TOKEN_KEY;
//@ts-expect-error window.ENV
export const ACCESS_TOKEN_TIME = window.ENV.ACCESS_TOKEN_TIME_KEY;
//@ts-expect-error window.ENV
export const ACCESS_TOKEN_EXPIRE_TIME = window.ENV.ACCESS_TOKEN_EXPIRE_TIME_KEY;
//@ts-expect-error window.ENV
export const REFRESH_TOKEN_KEY = window.ENV.REFRESH_TOKEN_KEY;
//@ts-expect-error window.ENV
export const CREATE_ACCOUNT_URL = window.ENV.CREATE_ACCOUNT_URL;



// Sets a browser cookie with an expiry time (in seconds).
// Used to persist auth tokens (access, refresh, id) across page reloads.
export const setCookie = (name: string, value: string, expierIn: number): void =>
{
    // Guard for SSR environments where document is not available.
    if (typeof document === 'undefined')
    {
        return;
    }

    const now = new Date();
    now.setTime(now.getTime() + expierIn * 1000);
    const expires = now.toUTCString();

    // Encode value to handle special characters like ';' or '=' safely in the cookie string.
    const encodedValue = encodeURIComponent(value);

    // Only add `Secure` on HTTPS — setting it on http://localhost causes the browser to drop the cookie.
    const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';

    // SameSite=Lax prevents CSRF on top-level navigations while keeping normal app flows working.
    document.cookie = `${ name }=${ encodedValue }; expires=${ expires }; path=/${ secureAttr }; SameSite=Lax`;
}


export const getCookie = (name: string) =>
{
    if (typeof document === 'undefined')
    {
        return undefined;
    }

    const cookies = document.cookie.split('; ');
    for (const cookie of cookies)
    {
        const separatorIndex = cookie.indexOf('=');
        if (separatorIndex < 0) continue;

        const key = cookie.slice(0, separatorIndex);
        if (key !== name) continue;

        const rawValue = cookie.slice(separatorIndex + 1);
        try
        {
            return decodeURIComponent(rawValue);
        }
        catch
        {
            return rawValue;
        }
    }
    return undefined;
}

export const getUserIdFromIDToken = (token: string): string =>
{
    try
    {
        const parts = token.split('.');

        if (parts.length !== 3)
        {
            throw new Error("Invalid token");
        }

        const b64 = parts[ 1 ].replace(/-/g, '+').replace(/_/g, '/');
        const { sub } = JSON.parse(atob(b64));

        return sub;

    } catch (error: any)
    {
        notifyError(error.message ?? 'Invalid token');
    }

    return '';
}
export const removeCookie = (name: string) =>
{
    if (typeof document === 'undefined')
    {
        return;
    }

    document.cookie = `${ name }=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};